module.exports = ".LoginPage{padding-top:7vh;max-width:320px;margin:auto}\n"